/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const assetAuditServices = {
	fetchAssetAuditList,
	transitionAssetAudit,
	exportAssetAudits,
	fetchAuditableAssetTypes,
	createAssetAudit,
	exportTypedCounts,
	importTypedCounts,
};

function post(url, req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function fetchAssetAuditList(req = {}) {
	return post(endpoints.ASSET_AUDITS_LIST, req);
}

/** Only asset types marked `inwarded` come back — wizard step 3. */
function fetchAuditableAssetTypes(req = {}) {
	return post(endpoints.ASSET_AUDIT_ASSET_TYPES, req);
}

/**
 * Starts one audit per selected store in a single call.
 * Payload: {storeIds: [], assetTypeIds: [], name?}
 *
 * The whole request is refused if any one store fails a guard. It goes through
 * handleResponse like every other call here: handleResponse toasts the
 * backend's errorMessage verbatim — so the guard text ("already has an open
 * asset audit", "part way through dispatch", "not marked as inwarded") still
 * reaches the user — AND it routes an expired token to the logout path, which
 * a raw res.json() would swallow into a meaningless error toast.
 */
function createAssetAudit(req = {}) {
	return post(endpoints.ASSET_AUDITS_START, req);
}

/**
 * Unified lifecycle transition, same shape as the process audit's.
 * Payload: {auditId, storeId, targetStatus}
 * Only CANCELLED is accepted today.
 */
function transitionAssetAudit(req = {}) {
	return post(endpoints.ASSET_AUDIT_STATUS_CHANGE, req);
}

/**
 * CSV of the audits the current filters select, one row per asset type.
 * Returns the raw Response — the caller streams it through
 * handleResponseStreamDownload, so it must NOT go through handleResponse.
 */
function exportAssetAudits(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(endpoints.ASSET_AUDITS_EXPORT, requestOptions);
}

/**
 * Ticket 08 — server-built CSV of this audit's non-traceable asset types,
 * blank Quantity column for the operator to fill in.
 * Payload: {auditId, storeId}
 * Same "raw Response, streamed by the caller" shape as exportAssetAudits —
 * this is a real CSV file, not JSON, so it must NOT go through handleResponse.
 */
function exportTypedCounts(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({
			...(req?.data ?? {}),
		}),
	};
	return fetch(endpoints.ASSET_AUDIT_TYPED_COUNT_EXPORT, requestOptions);
}

/**
 * Ticket 08 — upload a filled-in typed-count CSV.
 * Payload: {auditId, storeId, updatedAudit} (base64 file), same key shape as
 * the store audit's uploadAuditStock, on purpose (reuses the same modal).
 * Only accepted while the audit is ACTIVE. Returns JSON — per-row outcomes
 * (applied/ignored/errors) travel inside a 200, so the caller must read
 * `data` even on success, not just toast `message`.
 */
function importTypedCounts(req = {}) {
	return post(endpoints.ASSET_AUDIT_TYPED_COUNT_IMPORT, req);
}

export default assetAuditServices;
